import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';

import { FormValidators } from 'src/app/shared/form-error/form.validators';
import { Status } from 'src/app/core/services/http/general/enums/status';

export function getFormGroup(): UntypedFormGroup {
  // tslint:disable-next-line deprecation
  return new UntypedFormBuilder().group(
    {
      ...{
        uuid: [],
        name: [, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
        startDate: [, [Validators.required]],
        endDate: [, [Validators.required]],
        startTime: [, [Validators.required]],
        startTimeSelector: [],
        endTime: [, [Validators.required]],
        endTimeSelector: [],
        cutoffTimeSelector: [],
        cutoffTime: [, [Validators.required]],
        recurrence: [],
        cutoffDays: [0, [Validators.required, FormValidators.onlyPositiveNumbers]],
        cutOffCountWeekends: [false],
        controlledAccessPeriod: [],
        controlledAccessPeriodState: [],
        controlledAccessPeriodRoster: [],
        lunch: [],
        catchallRoom: [],
        lunchRoom: [],
        catchallFile: [],
        catchAllByRoomDefaultTeacherCollection: [],
        lunchAttendanceCapacity: [],
        enforceRoomCapacity: [false],
        catchAllSchedules: [[]],
        cap: [],
        catchall: [],
        catchallState: [],
        catchallTitle: [],
        status: [Status.Active],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        updateCatchall: [false],
        autoAssignFile: [],
        autoAssignRoom: [],
        autoAssignDefaultTeacherCollection: []
      },
      ...getAdditionalControlsForFiltering()
    },
    {
      validator: validateStartEndTime
    }
  );
}

export function validateStartEndTime(form: UntypedFormGroup): ValidationErrors {
  const message = {
    validateStartEndTime: {
      message: ''
    }
  };

  let result: any = message;

  if (form.controls.startTimeSelector.value > form.controls.endTimeSelector.value) {
    message.validateStartEndTime.message = 'STARTTIME_CANT_GREATER_THAN_ENDTIME';
  } else if (form.controls.endTimeSelector.value < form.controls.startTimeSelector.value) {
    message.validateStartEndTime.message = 'ENDTIME_CANT_LOWER_THAN_STARTTIME';
  }

  if (!message.validateStartEndTime.message) {
    result = null;
  }

  return result;
}

export function getAdditionalControlsForFiltering(): Record<string, AbstractControl> {
  return new UntypedFormBuilder().group({
    priority: [],
    activityType: [],
    defaultRoom: [],
    graduationYear: null,
    cutStatus: null,
    sisAttendanceStatus: null,
    attendanceStatus: null,
    createdBy: null,
    room: [],
  }).controls;
}
